/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterBuilderColumnDto
 */
export interface FilterBuilderColumnDto {
    /**
     * 
     * @type {string}
     * @memberof FilterBuilderColumnDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterBuilderColumnDto
     */
    type?: string;
}

/**
 * Check if a given object implements the FilterBuilderColumnDto interface.
 */
export function instanceOfFilterBuilderColumnDto(value: object): value is FilterBuilderColumnDto {
    return true;
}

export function FilterBuilderColumnDtoFromJSON(json: any): FilterBuilderColumnDto {
    return FilterBuilderColumnDtoFromJSONTyped(json, false);
}

export function FilterBuilderColumnDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterBuilderColumnDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function FilterBuilderColumnDtoToJSON(value?: FilterBuilderColumnDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'type': value['type'],
    };
}

